import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-line-detail-dialog',
  templateUrl: './sales-order-line-detail-dialog.component.html',
  styleUrls: ['./sales-order-line-detail-dialog.component.scss']
})
export class SalesOrderLineDetailDialogComponent implements OnInit {

  stockOnHand: any[] = [];
  inventoryMovement: any[] = [];
  prices: any[] = [];
  scts: any[] = [];
  jobs: any[] = [];
  mtoPos: any[] = [];

  loading: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      stockCode: string;
      storeId: number;
      salesOrderHeaderId: number;
      salesOrderNumber: string;
      lineNumber: number;
    },
    private baseService: BaseService,
  ) { }

  ngOnInit(): void {
    this.baseService.executeCommand<any>('portal_sales_order_stock_code_details', { stockCode: this.data.stockCode, salesOrderHeaderId: this.data.salesOrderHeaderId, salesOrderNumber: this.data.salesOrderNumber, salesOrderLine: this.data.lineNumber })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.loading = false;
          this.stockOnHand = response.data.stockOnHand || [];
          this.inventoryMovement = response.data.inventoryMovement || [];
          this.prices = response.data.prices || [];
          this.scts = response.data.scts || [];
          this.jobs = response.data.jobs || [];
          this.mtoPos = response.data.mtoPos || [];
        }
      });
  }

  get sctsTitle(): string {
    return `SCTs (${this.scts?.length})`;
  }

  get jobsTitle(): string {
    return `Jobs (${this.jobs?.length})`;
  }

  get mtoPosTitle(): string {
    return `MTO POs (${this.mtoPos?.length})`;
  }
}
